module.exports = __webpack_public_path__ + "img/ufa-bet-support.2d995c59.png";